import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import produce, { immerable } from 'immer';
import { Map } from 'immutable';

import { TraceItemEntity } from './trace-item.entity';

export interface ITraceListExtra extends IListColumnConfig<TraceItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
	visibleIndex?: number;
	visible?: boolean;
	hasHeaderFilter?: boolean;
}

interface ITraceListEntity extends IListAttrs<TraceItemEntity> {
	availableColumns: Map<string, ITraceListExtra>;
}

const entityDefaults: ITraceListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class TraceListEntity
	implements
		ITraceListEntity,
		IListOperations<TraceListEntity, TraceItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(availableCols: Array<ITraceListExtra>): TraceListEntity {
		const instance = new TraceListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, ITraceListExtra]>());

		instance.availableColumns = Map(cols);
		return instance;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<TraceItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(elems: Map<string, TraceItemEntity>): TraceListEntity {
		return produce(this, (draft: TraceListEntity) => {
			draft.elements = elems;
		});
	}
}
